import { createContext, useState } from 'react';
import api from 'services/api';

export const DropsContext = createContext();

export const DropsProvider = ({ children }) => {
  const [drops, setDrops] = useState({});
  const [dropLoading, setDropLoading] = useState(false);

  const getDrops = async (models = []) => {
    try {
      setDropLoading(true);
      const body = {};
      models?.forEach((m) => {
        body[m] = true;
      });
      const { data } = await api.post(`/Drops`, body);
      setDrops((prev) => ({ ...prev, ...data }));
    } catch (error) {
    } finally {
      setDropLoading(false);
    }
  };

  return (
    <DropsContext.Provider value={{ getDrops, drops, dropLoading }}>
      {children}
    </DropsContext.Provider>
  );
};
